import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { FUNC_DEFAULT, OBJECT_DEFAULT } from 'constants';
import usePaytoAPI from 'features/to/hooks/payment/usePaytoAPI';
import useCommonStore from 'hooks/useCommonStore';
import usePortalModal from 'hooks/usePortalModal';
import React from 'react';

const withPayByPayto = (Component) => {
  const PayByPaytoComponent = (props) => {
    const { showPortalModalName } = usePortalModal();
    const { paytoAccountInformation, setPending } = useCommonStore();
    const { checkReceiverVerifiedByOTP } = usePaytoAPI();

    const showPaytoOTPVerificationModal = (
      transactionPayload = OBJECT_DEFAULT,
      callback = FUNC_DEFAULT,
      callbackClose = FUNC_DEFAULT
    ) => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.PAYTO_OTP_VERIFICATION_MODAL,
        action: callback,
        actionClose: callbackClose,
        modalData: { transactionPayload },
      });
    };

    const onPaytoPaymentProcessing = async (
      transactionPayload,
      handleOnPay,
      successCallback = FUNC_DEFAULT,
      errorCallback = FUNC_DEFAULT
    ) => {
      setPending(true);

      const transactionPayloadByPayto = {
        ...transactionPayload,
        otp: transactionPayload?.otp,
        agreementUID: paytoAccountInformation?.id,
      };
      handleOnPay(transactionPayloadByPayto, successCallback, errorCallback);
    };

    const onCheckReceiverVerifiedByOTP = (
      receiverId,
      callback = FUNC_DEFAULT,
      errorCallback = FUNC_DEFAULT,
      isResendViaEmail = false
    ) => {
      return checkReceiverVerifiedByOTP(
        receiverId,
        callback,
        errorCallback,
        isResendViaEmail
      );
    };

    const newProps = {
      ...props,
      onCheckReceiverVerifiedByOTP,
      onPaytoPaymentProcessing,
      showPaytoOTPVerificationModal,
    };
    return <Component {...newProps} />;
  };
  return PayByPaytoComponent;
};

export default withPayByPayto;
